import * as React from 'react';
import { Permission, To } from '../../Types';
import PermissionContext from './PermissionContext';
import { useRecoilValue } from 'recoil';
import { AUsers } from '../../atoms/global/users';
import { Owner } from '../orders/model/Model';

// import * as casbinjs from 'casbin.js'

interface Props {
  permission: Permission
  isSuperAdmin: boolean
  children: JSX.Element | string | JSX.Element[] | string[]
  teamUsers: number[]
}

// type PermissionCache = {
//     [key: string]: boolean;
// }

// const beta: ObjectAction[] = [
//     'dashboard',
// ];

// const beta_actions: Policy = {
//     company: ['create', 'update', 'delete'],
//     free_forms: ['create', 'update', 'delete'],
//     catalog: ['create', 'update', 'delete'],
//     opportunity: ['create', 'update', 'delete'],
//     order: ['create', 'update', 'delete'],
//     map: ['create', 'update', 'delete'],
//     shelf_audit: ['create', 'update', 'delete'],
//     calendar: ['create', 'update', 'delete'],
//     contact: ['create', 'update', 'delete']
// }

// function checkScope(permissionScope: Scope, toScope: Scope | undefined, isSelf: boolean): boolean {
//     if (!toScope) return true
//     switch (permissionScope) {
//         case 'Company': return true
//         case 'User': return toScope == 'User' && isSelf
//         case 'Nothing': return false
//     }
// }

function can(to: To, perm: Permission, isSuperAdmin: boolean, isSelf: boolean | undefined, isInGroup: boolean | undefined): boolean {
	// if super admin, return true
	if (isSuperAdmin) {
		return true;
	}

	// // if permission is in beta, return true
	// if (beta.includes(to.objectAction)) {
	//     return true
	// }

	// // if permission action is in beta_actions, return true
	// if (to.objectAction in beta_actions && beta_actions[to.objectAction] == to.scope) {
	//     return true;
	// }

	// // if no permission given then everything is allowed
	// if (!perm) {
	//     return true;
	// }

	// else, check for permission
	if (perm[to.objectAction] === 'User' && isSelf !== undefined) return isSelf;
	if (perm[to.objectAction] === 'Team' && isInGroup !== undefined) return isInGroup;
	return perm[to.objectAction] && perm[to.objectAction] !== 'Nothing';
	// if (perm.hasOwnProperty(to.act)) {
	//     // return perm[to.act].some(([obj, scope]) => obj == to.obj && checkScope(scope, to.scope, isSelf));
	//     return perm[to.act].some(obj => obj == to.obj);
	// }
	// return false;
}

export const isAllowedToWithPerm = (to: To | To[], permission: Permission, isSuperAdmin = false, opt: IsAllowedToProps | undefined, owners: Owner[], teamUsers: number[]): boolean => {
	if (isSuperAdmin) return true;
	if (!permission) return false;
	const userId = owners.find(o => o.isYou)?.id;
	let isSelf = opt?.isSelf;
	if (isSelf == undefined && opt?.ownerId !== undefined) {
		isSelf = owners.find(o => o.id == opt.ownerId)?.isYou ?? false;
	}
	const isInGroup = (opt?.isSelf !== undefined || opt?.ownerId !== undefined) && userId ? teamUsers.includes(userId) : undefined;
	if (Array.isArray(to)) {
		if (to.length == 0) return true;
		if (opt && opt.cumulative) return to.every(t => can(t, permission, isSuperAdmin, isSelf, isInGroup));
		return to.some(t => can(t, permission, isSuperAdmin, isSelf, isInGroup));
	}
	return can(to, permission, isSuperAdmin, isSelf, isInGroup);
};

export type IsAllowedToProps = {
	isSelf?: boolean | undefined,
	ownerId?: number | undefined,
	cumulative?: boolean | undefined
};

// This provider is intended to be surrounding the whole application.
// It should receive the users permissions as parameter
const PermissionProvider: React.FunctionComponent<Props> = ({ permission, children, isSuperAdmin, teamUsers }) => {
	const owners = useRecoilValue(AUsers);
	if (!owners.some(o => o.isYou)) return <></>;
	// Creates a method that returns whether the requested permission is available in the list of permissions
	// passed as parameter
	const isAllowedTo = (to: To | To[], opt?: IsAllowedToProps): boolean => isAllowedToWithPerm(
		to,
		permission,
		isSuperAdmin,
		opt,
		owners,
		teamUsers
	);

	const getPermissions = (): Permission => permission;

	// This component will render its children wrapped around a PermissionContext's provider whose
	// value is set to the method defined above
	return <PermissionContext.Provider value={{ isAllowedTo, getPermissions }}>{children}</PermissionContext.Provider>;
};

export default PermissionProvider;
